import { render, staticRenderFns } from "./DownloadDialog.vue?vue&type=template&id=6f6b64dd&"
import script from "./DownloadDialog.vue?vue&type=script&lang=js&"
export * from "./DownloadDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports